import { useParams } from 'react-router-dom';
import { collection, query, orderBy } from 'firebase/firestore';
import { useFirestore, useFirestoreCollectionData } from 'reactfire';

import { List, ListItemButton, ListItemText } from '@mui/material';
import {
  ConversationLink,
  StyledListItem,
} from '../../../styled/Sidebar.styled';

import { ChatMessage } from '../../../types';
import { getFormattedDate } from '../../../utils/dateFormat';

interface ConversationsListProps {
  userId: string;
  isNestedList?: boolean;
}

const ConversationsList = ({
  userId,
  isNestedList,
}: ConversationsListProps) => {
  const firestore = useFirestore();
  const { sessionId } = useParams();

  const conversationsCollection = collection(
    firestore,
    `chats/${userId}/conversations`,
  );
  const conversationsQuery = query(
    conversationsCollection,
    orderBy('createdAt', 'desc'),
  );

  const { data: conversations } = useFirestoreCollectionData(
    conversationsQuery,
    {
      idField: 'id',
    },
  );

  return (
    <List>
      {conversations.map((conversation, index) => {
        const userMessage = conversation.messages.filter(
          (message: ChatMessage) => message.kind === 'USER_MESSAGE',
        )[0];
        const primary = conversation.recordId
          ? conversation.recordId + ' - ' + getFormattedDate(conversation?.requestDate)
          : userMessage
            ? userMessage.text
            : `Історія ${index + 1}`;

        return (
          <ConversationLink
            to={`/${conversation.id}/${userId}`}
            key={conversation.id}
          >
            <StyledListItem
              isSelectedItem={sessionId === conversation.id}
              isNestedList={isNestedList}
              disablePadding
            >
              <ListItemButton>
                <ListItemText primary={primary} />
              </ListItemButton>
            </StyledListItem>
          </ConversationLink>
        );
      })}
    </List>
  );
};

export default ConversationsList;
